import { ArrowLeft, ArrowUpRight, Fingerprint, KeyRound } from "lucide-react";
import { useTranslation } from "@/i18n";
import { VNextButton } from "@/components/brand/vnext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import "./wallet-welcome.css";

export type CreationAvailability = "checking" | "ready" | "unsupported" | "limit" | "failed";
export interface WalletCreationViewProps {
  name: string;
  onName: (value: string) => void;
  onCreate: () => void | Promise<void>;
  onBack: () => void;
  onRetry?: () => void;
  availability: CreationAvailability;
  busy?: boolean;
  error?: string;
}

export function WalletCreationView({ name, onName, onCreate, onBack, onRetry, availability, busy, error }: WalletCreationViewProps) {
  const { t } = useTranslation();
  return <div className="dt-wallet-create">
    <button type="button" className="dt-wallet-back" onClick={onBack} disabled={busy}><ArrowLeft aria-hidden="true" />{t("common.back")}</button>
    <div className="dt-wallet-intro"><span className="dt-wallet-symbol"><Fingerprint aria-hidden="true" /></span><h2>{t("welcome.setupTitle")}</h2><p>{t("welcome.setupDescription")}</p></div>
    <form onSubmit={event => { event.preventDefault(); if (availability === "ready" && !busy) void onCreate(); }}>
      <div className="dt-wallet-field"><Label htmlFor="wallet-name">{t("welcome.name")}<span>{t("welcome.optional")}</span></Label><Input id="wallet-name" placeholder={t("welcome.namePlaceholder")} value={name} onChange={event => onName(event.target.value)} disabled={busy} autoComplete="off" /></div>
      <div className="dt-wallet-explainer"><Fingerprint aria-hidden="true" /><div><h3>{t("welcome.deviceTitle")}</h3><p>{t("welcome.deviceDescription")}</p></div></div>
      <div className="dt-wallet-explainer"><KeyRound aria-hidden="true" /><div><h3>{t("welcome.backupTitle")}</h3><p>{t("welcome.backupDescription")}</p></div></div>
      {availability !== "ready" && <div className="dt-wallet-message" role="status"><p>{t(availability === "checking" ? "welcome.checking" : availability === "unsupported" ? "welcome.unsupported" : availability === "limit" ? "welcome.limit" : "welcome.checkFailed")}</p>{availability === "failed" && <button type="button" onClick={onRetry}>{t("welcome.retry")}</button>}</div>}
      {error && <p className="dt-wallet-error" role="alert">{error}</p>}
      <VNextButton type="submit" className="dt-welcome-primary" disabled={availability !== "ready" || busy}>{t("welcome.createWithDevice")}<ArrowUpRight aria-hidden="true" /></VNextButton>
    </form>
  </div>;
}

export function WalletCreationProgress({ step }: { step: "step1" | "step2" }) {
  const { t } = useTranslation();
  return <div className="dt-wallet-progress" role="status" aria-live="polite" aria-busy="true">
    <span className="dt-wallet-symbol"><Fingerprint aria-hidden="true" /></span>
    <h2>{t(step === "step1" ? "welcome.stepCredential" : "welcome.stepEncryption")}</h2>
    <p>{t(step === "step1" ? "welcome.credentialDetail" : "welcome.encryptionDetail")}</p>
    <ol className="dt-wallet-steps"><li aria-current={step === "step1" ? "step" : undefined}><span>1</span>{t("welcome.stepCredential")}</li><li aria-current={step === "step2" ? "step" : undefined}><span>2</span>{t("welcome.stepEncryption")}</li></ol>
    <p className="dt-wallet-progress-note">{t("welcome.actualProgress")}</p>
  </div>;
}
